module.exports = __webpack_public_path__ + "img/056.7b513b86.png";